export default {
  // API: 'http://localhost:10011', //后台API
  API: 'https://beizhan-api.ganvana.com',
  mapKey: 'KEUBZ-2WMKX-36J4G-ZVLHP-KDXJ7-JFFQ4', //腾讯地图key
  wechatApi: 'https://wechat.ganvana.com'
}
